<template>
    <Page withNavbar withNavigation>
        <main>
            <SectionTitle
                :title="config.THANKS_TITLE"
                :description="config.THANKS_DESCRIPTION"
            />
            <SectionPicture>
                <ArtThanks :color="config.COLOR_PRIMARY"/>
            </SectionPicture>
            <SectionText :text="config.THANKS_SHARE"/>
            <section class="social">
                <img class="network" src="../../assets/img/facebook.svg" @click="onShareFacebook"/>
                <img class="network" src="../../assets/img/twitter.svg" @click="onShareTwitter"/>
            </section>
        </main>
    </page>
</template>
<script>
import { SocialConsumer, SolutionConsumer, TrackingConsumer } from '../../mixins';
import { Page } from '../../components/mobile';
import { SectionTitle, SectionPicture, SectionText } from '../../components/shared';

export default {
    name: 'Thanks',
    components: {
        Page, SectionTitle, SectionPicture, SectionText,
    },
    mixins: [SocialConsumer, SolutionConsumer, TrackingConsumer],
    methods: {
        onShareFacebook () {
            this.trackEvent(this.isCasting ? 'CASTING_SHARE' : 'PLATFORM_SHARE');
            this.shareFacebook(this.shareUrl.href);
        },
        onShareTwitter () {
            this.trackEvent(this.isCasting ? 'CASTING_SHARE' : 'PLATFORM_SHARE');
            this.shareFacebook(this.shareUrl.href);
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/mixins';
@import '../../assets/scss/colors';

main {
    @include container(40px);
    align-content: center;
    flex-grow: 1;

    > section {
        &.social {
            text-align: center;

            > .network {
                @include square(32px);

                &:first-of-type {
                    margin-right: 16px;
                }
            }
        }
    }
}
</style>
